// left nav changes container
import { Component, Input, OnInit } from '@angular/core';
// end
import { MenuItem } from 'primeng/api';
import { UserDetails } from 'src/app/shared/models/user-details.model';
import { DopMenuService } from './dop-menu.service';
import { SettingFeatureFlags } from './models/setting-feature-flags.model';
import { SettingConfigurations } from './models/setting-configurations.model';
// left nav changes container
// import { AppRoute } from './models/app-route.model';
// import { NavigationEnd, Router } from '@angular/router';
// import { filter } from 'rxjs/operators';
// end

@Component({
  selector: 'dop-menu',
  templateUrl: './dop-menu.component.html',
  styleUrls: ['./dop-menu.component.scss']
})
export class DopMenuComponent implements OnInit {

  items: MenuItem[] = [];

  @Input() userDetails: UserDetails;
  @Input() eolWebsiteUrl: string;
  @Input() featureFlags: SettingFeatureFlags;
  @Input() configurations: SettingConfigurations;

  // left nav changes container
  // activeRoute = -1;
  // appRoute = AppRoute;
  // end

  constructor(
    private dopMenuService: DopMenuService,
    // left nav changes container
    // private renderer: Renderer2,
    // private elementRef: ElementRef,
    // private router: Router
    // end
  ) {
    // left nav changes container
    // this.router.events.pipe(
    //   filter(event => event instanceof NavigationEnd)
    // ).subscribe((event: NavigationEnd) => {
    //   if (event.url.indexOf('') !== -1) {
    //     this.activeRoute = this.appRoute.CREATEORDER;
    //   }
    // });
    // end
   }

  ngOnInit() {
    this.items = this.dopMenuService
      .loadMenuItems(this.userDetails, this.userDetails?.profile.displayName, this.featureFlags, this.configurations, this.eolWebsiteUrl);
    // left nav changes container
    // setTimeout(() => {
    //   const root = this.elementRef.nativeElement.getElementsByClassName('p-menubar-root-list');
    //   root[0].addEventListener('scroll', () => {
    //     this.updateMenuItem();
    //   }, true);
    //   this.updateMenuItem();
    // }, 800);
    // end
  }

  // left nav changes container
  // updateMenuItem() {
  //   const menuList = this.elementRef.nativeElement.getElementsByClassName('p-menu-parent');
  //   for (const menuItem of menuList) {
  //     const subMenu = menuItem.getElementsByClassName('p-submenu');
  //     const subMenuList = menuItem.getElementsByClassName('p-submenu-list');
  //     if (subMenu.length > 0 && subMenuList.length > 0) {
  //       subMenu[0].style.top = menuItem.getBoundingClientRect().top + 'px';
  //       subMenuList[0].style.maxHeight = 'calc(100vh - ' + menuItem.getBoundingClientRect().top + 'px)';
  //     }
  //   }
  // }
  // end
}
